module.exports = __webpack_public_path__ + "media/images/photography/sub-nav-ma-9708393e405afd599fe1dc70fd20f89d.jpg";